<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_635b99af32dbf7514c031f1b') }}{{customHeaderText}}</h1></div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i
        class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ ранг листе') }}</span>
      </div>
    </div>
    <div class="page-part">
      <div class="page-actions">
        <button class="btn btn-warning fl amno" (click)="back()">
          <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
          <!-- <button *ngIf="auth.isAuthorized('C1FCB642-9D20-4538-AB51-059562731B4F')"
            class="btn btn-success" (click)="routerNavigateToCreate()"><i
            class="fa fa-plus mr-1"></i> {{ translationManager.getTranslation('Додати нови') }}</button> -->
      </div>
    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span></div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span></div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype><span><i
            search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                              search-tag-prototype-value></i></span><a href="javascript:;"
                                                                                       [title]="translationManager.getTranslation('Обрисати филтер')"
                                                                                       search-tag-prototype-close><i
            class="fas fa-times"></i></a></div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
               order-tag-prototype><span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                                                             order-tag-prototype-value></i></span><a
            href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
            order-tag-prototype-close><i class="fas fa-times"></i></a></div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon"><a href="javascript:;"
                                              [title]="translationManager.getTranslation('Филтрирај ентитете')"
                                              filter-open><i class="fas fa-filter"></i></a></div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title"><span>{{ translationManager.getTranslation('Филтери') }}</span><a
              href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close><i
              class="fas fa-times"></i></a></div>
            <div class="page-part">
              <div class="alert alert-info"><span><i
                class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part"
                 [ngStyle]="{
                  'display': item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen') ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_auction_id')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="id"
                         [search-title-new]="translationManager.getTranslation('att_label_auction_id')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part"
                 [ngStyle]="{
                  'display': item && item.auctionUniqueIdentifier === 'AuctionOpen' ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_supplier_id')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="supplierId"
                         [search-title-new]="translationManager.getTranslation('att_label_supplier_id')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part"
                 [ngStyle]="{
                  'display': item && item.auctionUniqueIdentifier === 'AuctionOpen' ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b9bdb32dbf7514c031f21')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="supplierName"
                         [search-title-new]="translationManager.getTranslation('att_label_635b9bdb32dbf7514c031f21')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part"
                 [ngStyle]="{
                  'display': item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen') ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b9afb32dbf7514c031f1f')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="offeredPrice"
                         [search-title-new]="translationManager.getTranslation('att_label_635b9afb32dbf7514c031f1f')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part"
                 [ngStyle]="{
                  'display': item && item.auctionUniqueIdentifier === 'AuctionOpen' ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_635b9b2032dbf7514c031f20')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="offeredAmount"
                         [search-title-new]="translationManager.getTranslation('att_label_635b9b2032dbf7514c031f20')"
                         search-action="contains">
                </div>
              </div>
            </div>

            <div class="page-part"
                 [ngStyle]="{
                  'display': item && item.auctionUniqueIdentifier === 'AuctionOpen' ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Понуђена укупна цена')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="offeredTotal"
                         [search-title-new]="translationManager.getTranslation('Понуђена укупна цена')"
                         search-action="contains">
                </div>
              </div>
            </div>


            <div class="page-part"
                 [ngStyle]="{
                  'display': item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen' || item.auctionUniqueIdentifier === 'AuctionClosed') ? 'block' : 'none'
                 }"
            >
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_supplier_rang')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="supplierRang"
                         [search-title-new]="translationManager.getTranslation('att_label_supplier_rang')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
          <tr class="bgc-primary-tp2 text-white">
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="id">
                {{translationManager.getTranslation('att_label_auction_id')}}
              </a>
            </th>
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="supplierId">
                {{translationManager.getTranslation('att_label_supplier_id')}}
              </a>
            </th>
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="supplierName">
                {{translationManager.getTranslation('att_label_635b9bdb32dbf7514c031f21')}}
              </a>
            </th>
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="offeredPrice">
                {{translationManager.getTranslation('att_label_635b9afb32dbf7514c031f1f')}}
              </a>
            </th>
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="offeredAmount">
                {{translationManager.getTranslation('att_label_635b9b2032dbf7514c031f20')}}
              </a>
            </th>
            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="offeredTotal">
                {{translationManager.getTranslation('Понуђена укупна цена')}}
              </a>
            </th>
            

            <th *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen' || item.auctionUniqueIdentifier === 'AuctionClosed')">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                 order-entity="supplierRang">
                {{translationManager.getTranslation('att_label_supplier_rang')}}
              </a>
            </th>
<!--            <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>-->
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let xxx of items">
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen')">{{item.auctionId}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">{{xxx.requestRoundSupplierId}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">{{xxx.supplierName}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen')">{{xxx.offeredPrice | number:'1.2-2':'sr'}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen')">{{xxx.offeredAmount}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen')">{{xxx.offeredTotal | number:'1.2-2':'sr'}}</td>

            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionOpen' || item.auctionUniqueIdentifier === 'AuctionSemiOpen' || item.auctionUniqueIdentifier !== 'AuctionClosed')">
                {{xxx.supplierRang}}</td>
            <td *ngIf="item && (item.auctionUniqueIdentifier === 'AuctionClosed') && (xxx.supplierId === lSuppid)">
                {{xxx.supplierRang}}
            </td>



<!--            <td class="right">-->
<!--              <div class="table-actions"><a *ngIf="auth.isAuthorized('1CEAB6B3-E1AF-40BD-9A69-8256E00F5E1F')"-->
<!--                                            [routerLink]="['./details', xxx.id]"-->
<!--                                            [title]="translationManager.getTranslation('Детаљи')"><i-->
<!--                class="far fa-file"></i></a><a *ngIf="auth.isAuthorized('C1FCB642-9D20-4538-AB51-059562731B4F')"-->
<!--                                               [routerLink]="['./edit', xxx.id]"-->
<!--                                               [title]="translationManager.getTranslation('Измена')"><i-->
<!--                class="far fa-file-alt"></i></a><a *ngIf="auth.isAuthorized('8F5C71C0-A6A3-4C52-B89C-3860917D09CC')"-->
<!--                                                   href="javascript:;" (click)="showDeleteModalFor(xxx.id)" class="red"-->
<!--                                                   [title]="translationManager.getTranslation('Брисање')"><i-->
<!--                class="far fa-trash-alt"></i></a></div>-->
<!--            </td>-->
          </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span></div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span><select pagination-pages>
            <option>1</option>
          </select><span>{{ translationManager.getTranslation('од') }}</span><span pagination-pages-count>-</span><span
            class="app-table-pagination-arrows"><a href="javascript:;"
                                                   [title]="translationManager.getTranslation('Иди на почетак')"
                                                   pagination-first-page><i class="fas fa-angle-double-left"></i></a><a
            href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page><i
            class="fas fa-angle-left"></i></a></span><span class="app-table-pagination-arrows"><a href="javascript:;"
                                                                                                  [title]="translationManager.getTranslation('Следећа')"
                                                                                                  pagination-next-page><i
            class="fas fa-angle-right"></i></a><a href="javascript:;"
                                                  [title]="translationManager.getTranslation('Иди на крај')"
                                                  pagination-last-page><i
            class="fas fa-angle-double-right"></i></a></span><span>{{ translationManager.getTranslation('Број редова за приказ') }}</span><select
            pagination-sizes>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select></div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
            pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете артикал?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i
      class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i
      class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>
